"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            Colors: [
                'default',
                'brown',
                'summer',
                'grey',
                'purple',
                'indigo',
                'blue',
                'cyan',
                'teal',
                'green',
                'lime',
                'pink',
                'red',
                'orange',
                'amber'
            ],
            providers: []
        };
        GState.bind(this, [
            'tenant',
            'theme'
        ]);
        this.state.providers = this.state.tenant.settings && this.state.tenant.settings.SSO && this.state.tenant.settings.SSO.providers || [];
    },
    onSelectColor: async function (color) {
        this.saveSubChange('settings', 'theme.color', color);
        GState.set('theme', {
            ...this.state.theme,
            color
        });
        await import(`~/views/${ this.state.theme.name }/theme/${ color }/light`);
        await import(`~/views/${ this.state.theme.name }/theme/${ color }/dark`);
    },
    onSelectProvider: function (value, add) {
        if (add) {
            if (this.state.providers.includes(value))
                return;
            this.state.providers.push(value);
        } else
            this.state.providers = this.state.providers.filter(each => {
                return each !== value;
            });
        this.saveSubChange('settings', 'SSO.providers', this.state.providers);
    },
    saveSubChange: function (target, name, value) {
        GState.tenant.update({ [name]: typeof value == 'object' && value.target ? value.target.value : value }, target);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Admin/sections/General.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_SSOPs = require("json/SSOPs"),
    SSOPs = module_SSOPs.default || module_SSOPs,
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_attrs0 = {
        "class": "my-3"
      },
    marko_attrs1 = {
        "class": "mb-2"
      },
    marko_attrs2 = {
        "class": "font-medium-2 mb-4"
      },
    marko_attrs3 = {
        "class": "my-3"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("db224c"),
    marko_node0 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs5 = {
        "for": "enable-sso",
        "class": "font-medium-1"
      },
    marko_attrs6 = {
        "class": "list-unstyled ml-5"
      },
    marko_attrs7 = {
        "class": "my-3"
      },
    marko_node1 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs8 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs9 = {
        "for": "allow-ui-tool",
        "class": "font-medium-1"
      },
    marko_node2 = marko_createElement("br", null, "36", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("br", null, "37", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs11 = {
        "for": "default-learner-page",
        "class": "font-medium-1"
      },
    marko_node4 = marko_createElement("br", null, "42", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("br", null, "43", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs12 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs13 = {
        "for": "learner-bg-image",
        "class": "font-medium-1"
      },
    marko_attrs14 = {
        "class": "col-xl-3 col-lg-4 col-5 d-flex justify-content-center text-center"
      },
    marko_attrs15 = {
        "class": "col"
      },
    marko_attrs16 = {
        "class": "list-inline"
      },
    marko_node6 = marko_createElement("div", {
        "class": "w-100 text-center"
      }, "10", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-check font-large-4 white-text"
        }, null, null, 0),
    marko_attrs17 = {
        "class": "my-50"
      },
    marko_attrs18 = {
        "class": "checkbox checkbox-secondary"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Row_tag({
      col: [
          {
              ns: "col-7",
              qs: "col-11",
              hs: "col-11",
              renderBody: function(out) {
                out.be("section", marko_attrs0, "2", component);

                out.be("h6", marko_attrs1, "3", component);

                Locale_tag({
                    text: "Themes & Colors",
                    class: "text-muted"
                  }, out, __component, "4");

                out.ee();

                out.be("p", marko_attrs2, "5", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Choose the theme color that matches your institution's branding the best");
                    }
                  }, out, __component, "6");

                out.ee();

                Row_tag({
                    class: "m-0 d-flex align-items-center",
                    renderBody: function(out) {
                      out.e("div", marko_attrs14, "8", component, 1)
                        .e("div", {
                            "class": marko_classValue("d-flex align-items-center round " + (state.theme && state.theme.color)),
                            style: "width:110px;height:110px;"
                          }, "9", component, 1, 1)
                          .n(marko_node6, component);

                      out.be("div", marko_attrs15, "12", component);

                      out.be("ul", marko_attrs16, "13", component);

                      marko_forOf(state.Colors, function(color, index) {
                        var $keyValue$0 = "@" + index,
                            $keyScope$0 = "[" + ($keyValue$0 + "]");

                        out.e("li", {
                            "class": "p-50 cursor-pointer",
                            title: color.toCapitalCase()
                          }, $keyValue$0, component, 1, 0, {
                            onclick: __component.d("click", "onSelectColor", false, [
                                color
                              ])
                          })
                          .e("div", {
                              "class": marko_classValue(marko_classValue([
                                "rounded",
                                color
                              ])),
                              title: color.toCapitalCase(),
                              style: "width:20px;height:20px"
                            }, "14" + $keyScope$0, component, 0);
                      });

                      out.ee();

                      out.ee();
                    }
                  }, out, __component, "7");

                out.ee();

                out.be("section", marko_attrs3, "15", component);

                out.be("h6", null, "16", component);

                Locale_tag({
                    text: "Authentication",
                    class: "text-muted"
                  }, out, __component, "17");

                out.ee();

                out.n(marko_node0, component);

                const isEnabled = state.tenant && state.tenant.settings && state.tenant.settings.SSO && state.tenant.settings.SSO.enabled

                out.be("div", marko_attrs4, "19", component);

                out.e("input", {
                    type: "checkbox",
                    id: "enable-sso",
                    checked: isEnabled
                  }, "20", component, 0, 0, {
                    onchange: __component.d("change", e => component.saveSubChange( 'settings', 'SSO.enabled', e.target.checked ), false)
                  });

                out.be("label", marko_attrs5, "21", component);

                Locale_tag({
                    text: "Enable Single Sign-On (SSO)",
                    class: "font-medium-2"
                  }, out, __component, "22");

                out.ee();

                out.ee();

                out.be("ul", marko_attrs6, "23", component);

                var $for$0 = 0;

                marko_forIn(SSOPs, function(provider, { label, icon, def }) {
                  var $keyScope$1 = "[" + (($for$0++) + "]");

                  if (def) {
                    out.be("li", marko_attrs17, "24" + $keyScope$1, component);

                    out.be("div", marko_attrs18, "@" + provider, component);

                    out.e("input", {
                        type: "checkbox",
                        id: "sso-provider-" + provider,
                        disabled: !isEnabled,
                        checked: state.providers.includes(provider)
                      }, "25" + $keyScope$1, component, 0, 0, {
                        onchange: __component.d("change", e => isEnabled && component.onSelectProvider( provider, e.target.checked ), false)
                      });

                    out.be("label", {
                        "for": "sso-provider-" + provider,
                        "class": "font-medium-1"
                      }, "26" + $keyScope$1, component);

                    Locale_tag({
                        text: label + " Auth",
                        class: "font-medium-2"
                      }, out, __component, "27" + $keyScope$1);

                    out.ee();

                    out.ee();

                    out.ee();
                  }
                });

                out.ee();

                out.ee();

                out.be("section", marko_attrs7, "28", component);

                out.be("h6", null, "29", component);

                Locale_tag({
                    text: "Advanced",
                    class: "text-muted"
                  }, out, __component, "30");

                out.ee();

                out.n(marko_node1, component);

                out.be("div", marko_attrs8, "32", component);

                out.e("input", {
                    type: "checkbox",
                    id: "allow-ui-tool",
                    checked: (state.tenant && state.tenant.settings) && state.tenant.settings.translate
                  }, "33", component, 0, 0, {
                    onchange: __component.d("change", e => component.saveSubChange( 'settings', 'translate', e.target.checked ), false)
                  });

                out.be("label", marko_attrs9, "34", component);

                Locale_tag({
                    text: "Allow UI translation tool display on pages",
                    class: "font-medium-2"
                  }, out, __component, "35");

                out.ee();

                out.ee();

                out.n(marko_node2, component);

                out.n(marko_node3, component);

                out.be("div", marko_attrs10, "38", component);

                out.e("input", {
                    type: "checkbox",
                    id: "default-learner-page",
                    checked: ((state.tenant && state.tenant.settings) && state.tenant.settings.learners) && (state.tenant.settings.learners.defaultPage === "explore")
                  }, "39", component, 0, 0, {
                    onchange: __component.d("change", e => component.saveSubChange( 'settings', 'learners.defaultPage', e.target.checked ? 'explore' : 'dashboard' ), false)
                  });

                out.be("label", marko_attrs11, "40", component);

                Locale_tag({
                    text: "Set learner explore page as default",
                    class: "font-medium-2"
                  }, out, __component, "41");

                out.ee();

                out.ee();

                out.n(marko_node4, component);

                out.n(marko_node5, component);

                out.be("div", marko_attrs12, "44", component);

                out.e("input", {
                    type: "checkbox",
                    id: "learner-bg-image",
                    checked: ((state.tenant && state.tenant.settings) && state.tenant.settings.learners) && state.tenant.settings.learners.bgImage
                  }, "45", component, 0, 0, {
                    onchange: __component.d("change", e => component.saveSubChange( 'settings', 'learners.bgImage', e.target.checked ), false)
                  });

                out.be("label", marko_attrs13, "46", component);

                Locale_tag({
                    text: "Display logo in pages background",
                    class: "font-medium-2"
                  }, out, __component, "47");

                out.ee();

                out.ee();

                out.ee();
              }
            }
        ]
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
